import { gql } from '@apollo/client'

const USERS = gql`
  query users($companyRole: String, $idSite: UUID, $user: String, $idRole: BigFloat) {
    users(
      filter: {
        companyRole: { includes: $companyRole }
        idRole: { notEqualTo: $idRole }
        and: { idSite: { equalTo: $idSite }, and: { email: { includes: $user } } }
      }
    ) {
      nodes {
        id
        idRole
        firstname
        lastname
        deliveryWorkDate
        email
        idSite
        isActive
        companyRole
        licensePlate
        transporterId
        transporter {
          id
          name
          firstNameContact
          lastNameContact
          email
          phoneNumber
          color
        }
        siteByIdSite {
          name
        }
        devicesByIdUser {
          nodes {
            id
            idDeviceSeed
            name
          }
        }
      }
      totalCount
      pageInfo {
        hasNextPage
      }
    }
  }
`

const USERS_PLANNING = gql`
  query users($companyRole: [String!], $orderBy: [UsersOrderBy!] = [FIRSTNAME_ASC, LASTNAME_ASC], $startDate: Date, $endDate: Date, $deliveryWorkDate: Datetime) {
    users(filter: { companyRole: { in: $companyRole },  transporterId: { isNull: false },deliveryWorkDate: { equalTo: $deliveryWorkDate } }, orderBy: $orderBy) {
      nodes {
        deliveryWorkDate
        id
        idRole
        firstname
        lastname
        email
        idSite
        isActive
        companyRole
        licensePlate
        driverOutOfOffices(
          filter: { oooDate: { greaterThanOrEqualTo: $startDate, lessThan: $endDate } }
        ) {
          nodes {
            id
            oooDate
          }
        }
        orderDeliveries(
          filter: { deliveryDate: { greaterThanOrEqualTo: $startDate, lessThan: $endDate } }
        ) {
          edges {
            node {
              command {
                clientName
                commandNumber
                contactName
                contactPhone
                comment
              }
              commandId
              commentDriver
              commentPrivate
              commentPublic
              deliveryDate
              deliveryTimeStart
              deliveryTimeEnd
              deliverySite {
                address
                city
                code
                id
                isSite
              }
              deliverySiteAddress
              deliverySiteBdn {
                address
                city
                code
                id
                isSite
              }
              deliverySiteBdnId
              deliverySiteCity
              deliverySiteId
              id
              licensePlate
              orderDeliveryMaterials {
                nodes {
                  material {
                    id
                    internalId
                    description
                    measureUnitByBaseMeasureUnitCode {
                      abbr
                    }
                    productCategoryByIdProductCategory {
                      family
                    }
                  }
                  commandMaterialId
                  id
                  materialId
                  quantity
                }
              }
              orderDeliveryNumber
              phoneNumber
              scanCmr
              scanProviderDeliveryNote
              scanSignature
              startingSite {
                address
                city
                code
                id
                isSite
              }
              startingSiteAddress
              startingSiteBdn {
                address
                city
                code
                id
                isSite
              }
              startingSiteBdnId
              startingSiteCity
              startingSiteId
              status
              unloadingSite {
                address
                city
                code
                id
                isSite
              }
              unloadingSiteAddress
              unloadingSiteBdn {
                address
                city
                code
                id
                isSite
              }
              unloadingSiteBdnId
              unloadingSiteCity
              unloadingSiteId
              user {
                firstname
                lastname
              }
              userId
            }
          }
        }
        transporterId
        transporter {
          id
          name
          firstNameContact
          lastNameContact
          email
          phoneNumber
          color
        }
      }
      totalCount
      pageInfo {
        hasNextPage
      }
    }
  }
`

const USER = gql`
  query user($id: UUID!) {
    user(id: $id) {
      companyRole
      deliveryWorkDate
      email
      firstname
      id
      idSite
      lastname
      licensePlate
      idRole
      transporterId
      transporter {
        id
        name
        firstNameContact
        lastNameContact
        email
        phoneNumber
        color
      }
    }
  }
`

const SITES = gql`
  query sites {
    sites {
      nodes {
        code
        name
        id
      }
      totalCount
    }
  }
`

const GET_SITE_BY_ID = gql`
  query getSiteById($id: UUID!) {
    site(id: $id) {
      code
      name
    }
  }
`

const ROLES = gql`
  query getRoles {
    roles {
      nodes {
        id
        displayName
        name
      }
      totalCount
    }
  }
`

const CREATE_USER = gql`
  mutation createUser(
    $email: String!
    $firstname: String!
    $idRole: BigFloat!
    $idSite: UUID!
    $lastname: String!
    $password: String = ""
    $transporterId: UUID
    $deliveryWorkDate: Datetime
    $tokenId: UUID
  ) {
    createUser(
      input: {
        user: {
          email: $email
          firstname: $firstname
          lastname: $lastname
          idSite: $idSite
          idRole: $idRole
          password: $password
          transporterId: $transporterId
          deliveryWorkDate: $deliveryWorkDate
          tokenId: $tokenId
        }
      }
    ) {
      user {
        id
        idRole
      }
    }
  }
`

const UPDATE_USER = gql`
  mutation updateUser(
    $id: UUID!
    $firstname: String
    $lastname: String
    $email: String
    $idRole: BigFloat
    $idSite: UUID
    $isActive: Boolean
    $transporterId: UUID
  ) {
    updateUser(
      input: {
        patch: {
          firstname: $firstname
          lastname: $lastname
          email: $email
          idRole: $idRole
          idSite: $idSite
          isActive: $isActive
          transporterId: $transporterId
        }
        id: $id
      }
    ) {
      clientMutationId
      user {
        id
        firstname
        lastname
        email
        idRole
        idSite
      }
    }
  }
`

const DELETE_USER = gql`
  mutation deleteUser($id: UUID!) {
    deleteUser(input: { id: $id }) {
      clientMutationId
    }
  }
`

const GET_ALL_DEVICE_FROM_USER = gql`
  query userDevices($id: UUID!) {
    user(id: $id) {
      devicesByIdUser {
        nodes {
          id
        }
      }
    }
  }
`

const CREATE_DRIVER_OUT_OF_OFFICE = gql`
  mutation createDriverOutOfOffice($userId: UUID!, $oooDate: Date!) {
    createDriverOutOfOffice(input: { driverOutOfOffice: { userId: $userId, oooDate: $oooDate } }) {
      driverOutOfOffice {
        id
      }
    }
  }
`

const DELETE_DRIVER_OUT_OF_OFFICE = gql`
  mutation deleteDriverOutOfOffice($id: UUID!) {
    deleteDriverOutOfOffice(input: { id: $id }) {
      clientMutationId
    }
  }
`

export default {
  USERS,
  USERS_PLANNING,
  USER,
  SITES,
  GET_SITE_BY_ID,
  ROLES,
  CREATE_USER,
  UPDATE_USER,
  DELETE_USER,
  GET_ALL_DEVICE_FROM_USER,
  CREATE_DRIVER_OUT_OF_OFFICE,
  DELETE_DRIVER_OUT_OF_OFFICE,
}